<mat-card class="m-auto padding12 home-card boxshadowgrey">
    <mat-card-content>
        <div class="home-card" id="content">
            <div class="home">
                <div class="home-nav">
                    <div class="home-nav-menu" cdkMenu>
                        <button mat-stroked-button class="mat-item-button" cdkMenuItem routerLink="/machineState" color="primary">
                            <mat-icon svgIcon="bagger"></mat-icon>
                            <span class="menu-item-label">{{"MASCHINESTATE.HEADER" | translate}}</span>
                        </button>
                        <button mat-stroked-button class="mat-item-button" cdkMenuItem routerLink="/dtc" color="primary">
                            <mat-icon>troubleshoot</mat-icon>
                            <span class="menu-item-label">{{"DTC.HEADER" | translate}}</span>
                        </button>
                        <button mat-stroked-button class="mat-item-button" cdkMenuItem routerLink="/canVisualization" color="primary">
                            <mat-icon>mediation</mat-icon>
                            <span class="menu-item-label">{{"BUS.HEADER" | translate}}</span>
                        </button>
                        <button mat-stroked-button class="mat-item-button" cdkMenuItem routerLink="/ioOverview" color="primary">
                            <mat-icon>settings_input_composite</mat-icon>
                            <span class="menu-item-label">{{"IO.MENUHEADER" | translate}}</span>
                        </button>
                        <ng-container *ngIf="this.roleService.isRole('Read_Data')">
                            <button mat-stroked-button class="mat-item-button" cdkMenuItem routerLink="/data" color="primary">
                                <mat-icon>settings</mat-icon>
                                <span class="menu-item-label">{{"EXPERT.MENUHEADER" | translate}}</span>
                            </button>
                        </ng-container>
                        <ng-container *ngIf="this.roleService.isRole('MO_Read')">
                            <button mat-stroked-button class="mat-item-button" cdkMenuItem routerLink="/machineOptions" color="primary">
                                <mat-icon>check_box</mat-icon>
                                <span class="menu-item-label">{{"OPTIONS.HEADER" | translate}}</span>
                            </button>
                        </ng-container>                    
                        <ng-container *ngIf="comissionEnabled && this.roleService.isRole('EOL') && (line == 'green' || line == 'crane') "><!--&& this.master_sw == '2.10.0'"-->
                        <button mat-stroked-button class="mat-item-button" cdkMenuItem routerLink="/comissioning" color="primary"  [disabled]="!ecuListSet">
                            <mat-icon>power</mat-icon>
                            <span class="menu-item-label">{{"COMISSION.MENUHEADER" | translate}}</span>
                        </button>
                        </ng-container>
                    </div>  
                </div>
                <div class="quickstart" (click)="quickstart()" #tooltip="matTooltip" [matTooltip]="('TOOLBAR.QUICKSTART_TIP' | translate)" matTooltipPosition="below">{{"MENU.QUICKSTART" | translate}}</div>    
            </div>
            <div class="home-info">
                <div class="info-header">
                    <div class="version-header">
                        <h2>{{"MENU.NUMBER" | translate}} {{this.machinenumber}}</h2>
                        <div class="version">
                            <a id="header">{{"MENU.VERSION" | translate}}</a>
                            <ng-container *ngIf="loading">
                                <div class="loading">
                                    <mat-progress-spinner mode="indeterminate" color="primary" diameter="35"></mat-progress-spinner>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="this.versions.length > 0">
                                <ng-container *ngIf="this.version_timestamp != ''">
                                    <a id="timestamp">({{this.version_timestamp | date:"dd/MM/yyyy HH:mm:ss"}})</a>
                                </ng-container>
                                <div class="version-info">
                                    <a class="datapoint" id="ecu" *ngFor="let version of versions">
                                        <a class="datapoint" id="name">{{version.name}}:</a>
                                        <a class="datapoint" id="value">{{version.version}}</a>
                                    </a>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="error">
                                <div class="errorMes">{{"ERROR.SW_VERSION.ERROR" | translate}} {{this.errorMessage}}</div>
                            </ng-container>
                        </div>
                        <!--<ng-container *ngIf="this.versions.length > 4">
                            <button mat-stroked-button (click)="showMore()">
                                <mat-icon>add</mat-icon>
                                <a>mehr anzeigen</a>
                            </button>
                        </ng-container>-->
                    </div>
                    <div class="home-image" id="container">
                        <img class="home-image" src="../../assets/images/machine/renderings/{{this.machinenumber.split('.')[0]}}.png" height="1350" width="1080" alt="Sennebogen Machine" (error)="updateUrl($event)" />
                    </div>
                </div>
                <div class="basis">
                    <div class="basis-info" id="left">
                        <!-- check for all binary -->
                        <ng-container *ngFor="let data of this.infoDataset.dataPoints">
                            <ng-container *ngIf="data.type == 'b'">
                                <div class="point" id="chip">
                                    <ng-container *ngIf="loadingInfo">
                                        <div class="loadingInfo">
                                            <mat-progress-spinner mode="indeterminate" color="primary" diameter="25"></mat-progress-spinner>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="!loadingInfo">
                                        <mat-chip class="point" [ngClass]="{'green': data.value === data.goodState, 'red': data.value !== data.goodState}"></mat-chip>
                                    </ng-container>
                                    <a class="point" id="name">{{data.trans | translate}}</a>    
                                </div>                        
                            </ng-container>
                        </ng-container>
                    </div>
                    <div class="basis-info">
                        <!-- check for non binary -->
                        <ng-container *ngFor="let data of this.infoDataset.dataPoints">
                            <ng-container *ngIf="data.type == 'nb'">
                                <div class="point" id="ecu">
                                    <a class="point" id="name">{{data.trans | translate}}:</a>
                                    <ng-container *ngIf="loadingInfo">
                                        <div class="loadingInfo">
                                            <mat-progress-spinner mode="indeterminate" color="primary" diameter="25"></mat-progress-spinner>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="!loadingInfo">
                                        <span class="point" id="value">
                                            {{ data.value }} {{ data.dataName.didInformation?.unit === 'mV' ? 'V' : data.dataName.didInformation?.unit}}
                                        </span>
                                    </ng-container>                            
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>   
                <!--<div class="quickstart" (click)="quickstart()" #tooltip="matTooltip" [matTooltip]="('TOOLBAR.QUICKSTART_TIP' | translate)" matTooltipPosition="below">Quickstart-Guide anzeigen</div>-->
            </div>
        </div>
    </mat-card-content>
</mat-card>
